// A not content that only contains numbers is stored as a number, not a string.
export default function toString(val) {
  if(typeof val === 'string') return val;
  if(val == null || isNaN(val)) return '';
  return '' + val;
}